<div id="ticket-detail-panel">
    <div class="support-info">
        <img src="../../assets/images/chat-bobble.svg" alt="support" />
        <div class="text-center">
            <h2>
                <!-- <span style="text-transform: capitalize;">{{$root.sharedUserInfo.name || $root.sharedUserInfo.email}}</span> -->
                {{ 'needs your help to reply to this customer support ticket.' | translate }}
            </h2>
            {{ 'Your answer will be sent directly to the customer' | translate }}
        </div>
    </div>

    <div class="md-whiteframe-z2 tickets-list md-whiteframe-z2 mt-3">
        <app-ticket-details></app-ticket-details>
    </div>
</div>
